/* Major 9 extra's: eigen dropdowns, taalkeuze, hulp bij lezen, meerdere genrefilters */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- 1. Selects in Major 9-stijl ---------- */
  function enhance(sel) {
    if (sel.__m9) return; sel.__m9 = true;
    var wrap = document.createElement('div'); wrap.className = 'm9sel';
    var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'm9sel__btn'; btn.setAttribute('aria-haspopup', 'listbox'); btn.setAttribute('aria-expanded', 'false');
    var lab = document.createElement('span'); btn.appendChild(lab);
    btn.insertAdjacentHTML('beforeend', '<svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true"><path d="M2 4.5 6 8l4-3.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>');
    var list = document.createElement('ul'); list.className = 'm9sel__list'; list.setAttribute('role', 'listbox'); list.hidden = true;
    sel.parentNode.insertBefore(wrap, sel); wrap.appendChild(sel); wrap.appendChild(btn); wrap.appendChild(list);
    sel.classList.add('vh'); sel.tabIndex = -1;
    function paint() {
      var o = sel.options[sel.selectedIndex]; lab.textContent = o ? o.text : '';
      list.innerHTML = '';
      Array.prototype.forEach.call(sel.options, function (op) {
        var li = document.createElement('li'); li.setAttribute('role', 'option'); li.tabIndex = 0; li.textContent = op.text; li.setAttribute('data-v', op.value);
        li.setAttribute('aria-selected', op.value === sel.value ? 'true' : 'false'); list.appendChild(li);
      });
    }
    function open(v) { list.hidden = !v; btn.setAttribute('aria-expanded', v ? 'true' : 'false'); wrap.classList.toggle('is-open', v); }
    paint();
    btn.addEventListener('click', function (e) { e.stopPropagation(); $$('.m9sel.is-open').forEach(function (w) { if (w !== wrap) { $('.m9sel__list', w).hidden = true; w.classList.remove('is-open'); } }); open(list.hidden); });
    list.addEventListener('click', function (e) {
      var li = e.target.closest('[data-v]'); if (!li) return; e.stopPropagation(); open(false);
      if (sel.value !== li.getAttribute('data-v')) { sel.value = li.getAttribute('data-v'); sel.dispatchEvent(new Event('change', { bubbles: true })); }
      paint();
    });
    list.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); e.target.click(); } if (e.key === 'Escape') { open(false); btn.focus(); } });
  }
  function enhanceAll() { $$('select[data-m9select]').forEach(enhance); }
  document.addEventListener('click', function (e) { if (!e.target.closest('.m9sel')) $$('.m9sel.is-open').forEach(function (w) { $('.m9sel__list', w).hidden = true; w.classList.remove('is-open'); $('.m9sel__btn', w).setAttribute('aria-expanded', 'false'); }); });

  /* ---------- 2. Taalkeuze ---------- */
  var NOTR = '.card__title,.card__artist,.pdp__title,.pdp__artist,.trk,.mini__t,.staff__a,.radio__t,.radio__s,.line__title,.upsell__t,.pred__t,.logo,.inline-buy__body a,.feat__title,.notranslate-auto';
  function cookie(n) { var m = document.cookie.match(new RegExp('(?:^|; )' + n + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : ''; }
  function setCookie(v) {
    var host = location.hostname, base = host.replace(/^www\./, '');
    var exp = v ? '' : ';expires=Thu, 01 Jan 1970 00:00:00 GMT';
    [host, '.' + base].forEach(function (d) { document.cookie = 'googtrans=' + (v || '') + ';path=/;domain=' + d + exp; });
    document.cookie = 'googtrans=' + (v || '') + ';path=/' + exp;
  }
  function target() { var c = cookie('googtrans'); var p = c.split('/'); return p[2] || ''; }
  function setLang(code) {
    var box = $('[data-lang]'); var native = box ? box.getAttribute('data-native').split(',') : ['nl'];
    var cur = box ? box.getAttribute('data-current') : 'nl';
    setCookie(code === 'nl' ? '' : '/nl/' + code);
    try { localStorage.setItem('m9-lang', code); } catch (e) {}
    var want = native.indexOf(code) > -1 ? code : 'nl';
    var f = box && $('[data-lang-form]', box);
    if (f && want !== cur) { $('input[name="language_code"]', f).value = want; f.submit(); }
    else location.reload();
  }
  window.M9lang = { set: setLang, current: function () { return target() || ($('[data-lang]') ? $('[data-lang]').getAttribute('data-current') : 'nl'); } };
  function initLang() {
    var boxes = $$('[data-lang]'); if (!boxes.length) return;
    boxes.forEach(initLangBox);
    var t = target();
    if (t && t !== 'nl') {
      $$(NOTR).forEach(function (n) { n.classList.add('notranslate'); n.setAttribute('translate', 'no'); });
      var el = document.createElement('div'); el.id = 'gt_el'; el.className = 'vh'; document.body.appendChild(el);
      window.m9gtInit = function () { try { new google.translate.TranslateElement({ pageLanguage: 'nl', autoDisplay: false }, 'gt_el'); } catch (e) {} };
      var s = document.createElement('script'); s.src = 'https://translate.google.com/translate_a/element.js?cb=m9gtInit'; s.async = true; document.head.appendChild(s);
      document.documentElement.classList.add('is-translated');
    }
  }
  function initLangBox(box) {
    var btn = $('[data-lang-btn]', box), list = $('[data-lang-list]', box), now = window.M9lang.current();
    $('[data-lang-code]', box).textContent = now.toUpperCase();
    $$('[data-code]', list).forEach(function (li) { li.tabIndex = 0; li.setAttribute('aria-selected', li.getAttribute('data-code') === now ? 'true' : 'false'); });
    btn.addEventListener('click', function (e) { e.stopPropagation(); list.hidden = !list.hidden; btn.setAttribute('aria-expanded', list.hidden ? 'false' : 'true'); });
    list.addEventListener('click', function (e) { var li = e.target.closest('[data-code]'); if (li) setLang(li.getAttribute('data-code')); });
    list.addEventListener('keydown', function (e) { if (e.key === 'Enter') e.target.click(); });
    document.addEventListener('click', function (e) { if (e.target.closest('[data-lang]') !== box) { list.hidden = true; btn.setAttribute('aria-expanded', 'false'); } });
  }

  /* ---------- 3. Hulp bij lezen ---------- */
  function initReadHelp() {
    var rh = $('[data-rh]'); if (!rh || rh.__m9) return; rh.__m9 = true;
    var btn = $('[data-rh-btn]', rh), panel = $('[data-rh-panel]', rh), body = $('.art__body');
    var store = {}; try { store = JSON.parse(localStorage.getItem('m9-rh') || '{}'); } catch (e) {}
    function save() { try { localStorage.setItem('m9-rh', JSON.stringify(store)); } catch (e) {} }
    function apply() { document.documentElement.classList.toggle('rh-big', !!store.big); document.documentElement.classList.toggle('rh-calm', !!store.calm); $('[data-rh-big]', rh).checked = !!store.big; $('[data-rh-calm]', rh).checked = !!store.calm; }
    apply();
    btn.addEventListener('click', function (e) { e.stopPropagation(); panel.hidden = !panel.hidden; btn.setAttribute('aria-expanded', panel.hidden ? 'false' : 'true'); });
    document.addEventListener('click', function (e) { if (!e.target.closest('[data-rh]')) { panel.hidden = true; btn.setAttribute('aria-expanded', 'false'); } });
    $('[data-rh-big]', rh).addEventListener('change', function (e) { store.big = e.target.checked; save(); apply(); });
    $('[data-rh-calm]', rh).addEventListener('change', function (e) { store.calm = e.target.checked; save(); apply(); });
    var ls = $('[data-rh-lang]', rh); ls.value = window.M9lang ? window.M9lang.current() : 'nl';
    ls.addEventListener('change', function () { if (window.M9lang) window.M9lang.set(ls.value); });
    // Kort samengevat
    var sb = $('[data-rh-sum]', rh), tpl = $('template[data-rh-summary]');
    sb.addEventListener('click', function () {
      var box = $('[data-rh-sumbox]');
      if (box) { box.remove(); sb.setAttribute('aria-expanded', 'false'); $('[data-rh-sum-label]', rh).textContent = 'tonen'; return; }
      if (!tpl || !body) return;
      body.insertBefore(tpl.content.cloneNode(true), body.firstChild);
      sb.setAttribute('aria-expanded', 'true'); $('[data-rh-sum-label]', rh).textContent = 'verbergen';
      var nb = $('[data-rh-sumbox]'); if (nb) nb.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    // Voorlezen
    var sp = $('[data-rh-speak]', rh), spl = $('[data-rh-speak-label]', rh), speaking = false;
    if (!('speechSynthesis' in window)) { sp.hidden = true; return; }
    function stopSpeak() { speechSynthesis.cancel(); speaking = false; spl.textContent = 'Voorlezen'; sp.classList.remove('is-on'); }
    sp.addEventListener('click', function () {
      if (speaking) { stopSpeak(); return; }
      if (!body) return;
      var lang = (window.M9lang ? window.M9lang.current() : 'nl'), map = { nl: 'nl-NL', en: 'en-GB', de: 'de-DE', fr: 'fr-FR', es: 'es-ES', it: 'it-IT' };
      var title = ($('.art-hero__title') || {}).innerText || '';
      var parts = (title + '. ' + body.innerText).replace(/\s+/g, ' ').match(/[^.!?]+[.!?]+|[^.!?]+$/g) || [];
      var voices = speechSynthesis.getVoices().filter(function (v) { return v.lang && v.lang.toLowerCase().indexOf(lang) === 0; });
      speechSynthesis.cancel(); speaking = true; spl.textContent = 'Stop met voorlezen'; sp.classList.add('is-on');
      parts.forEach(function (p, i) {
        var u = new SpeechSynthesisUtterance(p.trim()); u.lang = map[lang] || 'nl-NL'; if (voices[0]) u.voice = voices[0]; u.rate = 1;
        if (i === parts.length - 1) u.onend = stopSpeak;
        speechSynthesis.speak(u);
      });
    });
    window.addEventListener('pagehide', stopSpeak);
  }

  /* ---------- 4. Genrefilters: meerdere tegelijk ---------- */
  function chipSel(nav) { return $$('a[data-chip]', nav).filter(function (c) { return c.getAttribute('aria-pressed') === 'true'; }); }
  function handlesOf(h) {
    var all = [];
    function page(n) {
      return fetch('/collections/' + h + '/products.json?limit=250&page=' + n).then(function (r) { return r.json(); }).then(function (d) {
        var ps = d.products || []; ps.forEach(function (p) { all.push(p.handle); });
        return ps.length === 250 && n < 4 ? page(n + 1) : all;
      });
    }
    return page(1);
  }
  function cardsOf(h, want) {
    var out = [];
    function page(n) {
      return fetch('/collections/' + h + '?view=cards&page=' + n).then(function (r) { return r.text(); }).then(function (html) {
        var d = new DOMParser().parseFromString(html, 'text/html'), w = d.querySelector('[data-cards]');
        if (!w) return out;
        $$('[data-h]', w).forEach(function (x) { if (want[x.getAttribute('data-h')]) out.push(x.innerHTML); });
        var pages = parseInt(w.getAttribute('data-pages') || '1', 10);
        return n < pages && n < 12 ? page(n + 1) : out;
      });
    }
    return page(1);
  }
  function renderMulti(sec, nav, hs) {
    var res = $('[data-results]', sec); if (res) res.classList.add('is-loading');
    Promise.all(hs.map(handlesOf)).then(function (lists) {
      var sets = lists.map(function (l) { var o = {}; l.forEach(function (x) { o[x] = 1; }); return o; });
      var order = lists.map(function (l, i) { return [l.length, i]; }).sort(function (a, b) { return a[0] - b[0]; });
      var small = order[0][1], want = {};
      lists[small].forEach(function (x) { if (sets.every(function (s) { return s[x]; })) want[x] = 1; });
      var n = Object.keys(want).length;
      return (n ? cardsOf(hs[small], want) : Promise.resolve([])).then(function (cards) {
        var names = chipSel(nav).map(function (c) { return c.textContent.replace('×', '').trim(); }).join(' + ');
        var html = '<section class="wrap results" data-results>' + (cards.length
          ? '<div class="grid" data-grid>' + cards.join('') + '</div>'
          : '<div class="empty-col"><p style="font-size:20px;font-weight:600">Geen platen die ' + names + ' allebei zijn.</p><p>Haal een filter weg om meer te zien.</p></div>') + '</section>';
        var r = $('[data-results]', sec); if (r) r.outerHTML = html;
        var tools = $('[data-col-tools]', sec);
        if (tools) tools.innerHTML = '<div class="toolbar"><span class="multi-note">Filters: <strong>' + names + '</strong></span><div class="count">Je ziet<br><strong>' + cards.length + ' platen</strong></div></div>';
      });
    }).catch(function () { var r = $('[data-results]', sec); if (r) r.classList.remove('is-loading'); });
  }
  function loadSingle(sec, url) {
    var res = $('[data-results]', sec); if (res) res.classList.add('is-loading');
    return fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sec.getAttribute('data-col-section')).then(function (r) { return r.text(); }).then(function (html) {
      var d = new DOMParser().parseFromString(html, 'text/html');
      ['[data-col-tools]', '[data-results]'].forEach(function (s) { var o = $(s, sec), n = d.querySelector(s); if (o && n) o.outerHTML = n.outerHTML; });
    });
  }
  function applyChips(nav, push) {
    var sec = $('[data-col-section]'); if (!sec) return;
    var on = chipSel(nav), base = nav.getAttribute('data-base');
    var url;
    if (on.length === 0) { url = base; loadSingle(sec, url); }
    else if (on.length === 1) { url = on[0].getAttribute('href'); loadSingle(sec, url); }
    else { url = base + '?genres=' + on.map(function (c) { return c.getAttribute('data-handle'); }).join(','); renderMulti(sec, nav, on.map(function (c) { return c.getAttribute('data-handle'); })); }
    if (push) history.pushState({ chips: true }, '', url);
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-chip-filter] a[data-chip]');
    if (!a || e.metaKey || e.ctrlKey) return;
    e.preventDefault();
    var nav = a.closest('[data-chip-filter]'), on = a.getAttribute('aria-pressed') !== 'true';
    a.setAttribute('aria-pressed', on ? 'true' : 'false'); a.classList.toggle('is-active', on);
    applyChips(nav, true);
  });
  window.addEventListener('popstate', function (e) { if (e.state && e.state.chips) location.reload(); });
  function initChips() {
    var nav = $('[data-chip-filter]'); if (!nav) return;
    var m = location.search.match(/[?&]genres=([^&]+)/); if (!m) return;
    var hs = decodeURIComponent(m[1]).split(',');
    $$('a[data-chip]', nav).forEach(function (c) { var on = hs.indexOf(c.getAttribute('data-handle')) > -1; c.setAttribute('aria-pressed', on ? 'true' : 'false'); c.classList.toggle('is-active', on); });
    if (hs.length > 1) applyChips(nav, false);
  }


  /* ---------- 5. Artikel: eerste alinea als intro ---------- */
  function initLead() {
    var body = $('.art__body'); if (!body || body.__lead) return;
    var ps = $$('p, h4, h5, h6, blockquote', body).filter(function (p) { return !p.closest('.rh-sum, aside, .inline-buy, form, .comments') && p.textContent.trim().length > 40; });
    if (!ps.length) return; body.__lead = true; ps[0].classList.add('art-lead');
  }

  /* ---------- 6. Artikel: speler met nummers uit het verhaal ---------- */
  function jsonp(url) {
    return new Promise(function (res) {
      var n = 'm9j' + Math.random().toString(36).slice(2), s = document.createElement('script'), done = false;
      window[n] = function (d) { done = true; res(d); try { delete window[n]; } catch (e) {} s.remove(); };
      s.onerror = function () { if (!done) { done = true; res(null); } };
      s.src = url + '&callback=' + n; document.head.appendChild(s);
      setTimeout(function () { if (!done) { done = true; res(null); } }, 8000);
    });
  }
  function nrm(x) { return String(x || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\(.*?\)|\[.*?\]/g, '').replace(/feat\..*$/, '').replace(/[^a-z0-9 ]/g, ' ').replace(/\s+/g, ' ').trim(); }
  function initArtPlayer() {
    var box = $('[data-art-player]'); if (!box || box.__m9) return; box.__m9 = true;
    var albums = []; try { var a = JSON.parse(box.getAttribute('data-albums')); for (var i = 0; i + 3 < a.length + 1; i += 4) albums.push({ artist: a[i], album: a[i + 1], url: a[i + 2], pv: a[i + 3] || [] }); } catch (e) {}
    var play = $('[data-ap-play]', box), next = $('[data-ap-next]', box), title = $('[data-ap-title]', box), sub = $('[data-ap-sub]', box), bar = $('[data-ap-bar]', box), link = $('[data-ap-link]', box);
    var playIcon = play.innerHTML, pauseIcon = '<svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 5h4v14H6zM14 5h4v14h-4z" fill="currentColor"/></svg>';
    var queue = null, qi = 0, audio = null, loading = false, playing = false;
    function el() {
      if (audio) return audio;
      audio = new Audio();
      audio.addEventListener('timeupdate', function () { if (playing && audio.duration) bar.style.width = (audio.currentTime / audio.duration * 100) + '%'; });
      audio.addEventListener('ended', function () { if (!playing) return; if (qi + 1 < queue.list.length) start(qi + 1); else { playing = false; ui(false); bar.style.width = '0%'; title.textContent = 'Nog een keer luisteren'; } });
      audio.addEventListener('pause', function () { ui(false); });
      audio.addEventListener('play', function () { if (playing) ui(true); });
      return audio;
    }
    function ui(on) { play.innerHTML = on ? pauseIcon : playIcon; box.classList.toggle('is-playing', on); }
    function build() {
      var text = ' ' + nrm(($('.art__body') || document.body).innerText) + ' ';
      return Promise.all(albums.map(function (al) {
        return (window.M9find ? window.M9find(al.artist, al.album) : Promise.resolve([])).then(function (lst) { var d = { results: lst || [] };
          var a1 = nrm(al.artist.split(/,|&| and | feat/i)[0]).split(' ')[0], an = nrm(al.album);
          var found = ((d && d.results) || []).filter(function (r) {
            var c = nrm(r.collectionName);
            return r.previewUrl && nrm(r.artistName).indexOf(a1) > -1 && c && (c.indexOf(an) > -1 || an.indexOf(c) > -1);
          }).map(function (r) { r._al = al; return r; });
          if (!found.length && al.pv && al.pv.length) found = al.pv.map(function (x) { return { previewUrl: x.u, trackName: x.t, artistName: al.artist, trackTimeMillis: 120000, _al: al }; });
          return found;
        });
      })).then(function (lists) {
        var seen = {}, mentioned = [], fallback = [];
        lists.forEach(function (l) {
          l.forEach(function (r) {
            var k = nrm(r.trackName); if (!k || seen[k]) return; seen[k] = 1;
            var pos = k.length >= 4 ? text.indexOf(' ' + k + ' ') : -1;
            if (pos > -1) { r._pos = pos; mentioned.push(r); }
          });
          var good = l.filter(function (r) { return (r.trackTimeMillis || 0) > 90000 && !/intro|interlude|skit|outro/i.test(r.trackName); });
          if (good[0]) fallback.push(good[0]);
        });
        mentioned.sort(function (x, y) { return x._pos - y._pos; });
        return { list: mentioned.length ? mentioned : fallback, fromText: mentioned.length > 0 };
      });
    }
    function start(i) {
      if (!queue || !queue.list.length) { title.textContent = 'Geen fragment gevonden'; sub.textContent = 'Probeer het later nog eens'; ui(false); return; }
      qi = (i + queue.list.length) % queue.list.length; var r = queue.list[qi];
      el(); playing = true; audio.src = r.previewUrl;
      title.textContent = r.trackName;
      sub.textContent = r.artistName + (queue.list.length > 1 ? ' · ' + (qi + 1) + ' van ' + queue.list.length : '') + (queue.fromText ? ' · genoemd in dit verhaal' : '');
      next.hidden = queue.list.length < 2;
      if (r._al && r._al.url) { link.href = r._al.url; link.hidden = false; }
      audio.play().catch(function () { ui(false); });
    }
    play.addEventListener('click', function (e) {
      if (!e.isTrusted) return;
      if (playing && audio) { if (audio.paused) audio.play(); else audio.pause(); return; }
      if (queue) { start(0); return; }
      el(); if (window.M9_SILENT) { audio.src = window.M9_SILENT; var up = audio.play(); if (up && up.catch) up.catch(function () {}); }
      if (loading) { title.textContent = 'Even zoeken…'; var w = setInterval(function () { if (queue) { clearInterval(w); start(0); } }, 200); setTimeout(function () { clearInterval(w); }, 9000); return; }
      loading = true; title.textContent = 'Even zoeken…';
      build().then(function (q) { queue = q; loading = false; start(0); });
    });
    next.addEventListener('click', function (e) { if (e.isTrusted && queue) start(qi + 1); });
    // Op telefoons de nummers alvast opzoeken, zodat de eerste tik direct kan afspelen
    if (window.matchMedia && matchMedia('(pointer: coarse)').matches) setTimeout(function () { if (!queue && !loading) { loading = true; build().then(function (q) { queue = q; loading = false; }).catch(function () { loading = false; }); } }, 1200);
  }

  function init() { enhanceAll(); initLang(); initReadHelp(); initChips(); initLead(); initArtPlayer(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  var mq = 0; new MutationObserver(function () { if (mq) return; mq = requestAnimationFrame(function () { mq = 0; enhanceAll(); initReadHelp(); initLead(); initArtPlayer(); }); }).observe(document.documentElement, { childList: true, subtree: true });
})();
